var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAjnaLogo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 220,
    height: 220,
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M110 220c60.751 0 110-49.249 110-110S170.751 0 110 0 0 49.249 0 110s49.249 110 110 110Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M187.687 88.507C162.51 64.567 136.626 52 110.172 52c-26.453 0-52.337 12.567-77.515 36.507a5.377 5.377 0 0 0-.189 7.606 5.388 5.388 0 0 0 7.613.189C64.018 73.542 87.38 62.76 110.172 62.76c22.773 0 46.115 10.763 70.03 33.483.375.388.681.921.859 1.477a5.388 5.388 0 0 0-.096 1.015c0 1.271-.419 1.955-.76 2.247a5.642 5.642 0 0 0-.215.195c-.586.559-1.172 1.111-1.757 1.656-22.29-18.532-45.026-28.211-68.194-28.211-24.41 0-48.34 10.743-71.774 31.266a7.34 7.34 0 0 0-.13.107l-.058.05c-1.794 1.536-3.75 3.212-5.721 5.175-5.392 5.058-5.815 13.482-1.062 19.259l.098.152a5.586 5.586 0 0 0 1.536 1.54c25.006 23.604 50.707 35.99 76.97 35.99 26.453 0 52.337-12.567 77.515-36.506a5.377 5.377 0 0 0 .188-7.607 5.388 5.388 0 0 0-7.613-.188c-23.936 22.759-47.298 33.541-70.09 33.541-22.793 0-46.155-10.782-70.091-33.541l-.039-.037c-1.458-1.578-1.194-3.694-.02-4.776.052-.049.104-.099.154-.149a56.261 56.261 0 0 1 1.786-1.705c23.294 19.396 47.076 29.151 71.278 28.308 23.197-.808 45.904-11.323 68.111-30.736a5.37 5.37 0 0 0 1.683-1.488 201.255 201.255 0 0 0 4.578-4.233c2.633-2.315 3.88-5.373 4.263-8.273a5.344 5.344 0 0 0 .399-2.036c0-3.867-1.671-7.592-4.217-10.136a10.38 10.38 0 0 0-.096-.093Zm-77.648-3.124c19.543 0 39.5 7.955 59.99 24.64-19.561 16.065-38.691 24.072-57.438 24.725-20.372.71-41.204-7.232-62.612-24.669 20.515-16.723 40.495-24.695 60.06-24.695Z",
    fill: "#B5179E"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M110 90c-11.046 0-20 8.954-20 20s8.954 20 20 20 20-8.954 20-20-8.954-20-20-20Zm0 30c5.523 0 10-4.477 10-10s-4.477-10-10-10-10 4.477-10 10 4.477 10 10 10Z",
    fill: "#B5179E"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h220v220H0z"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAjnaLogo);
export default __webpack_public_path__ + "static/media/ajna-logo.0fe5d7ca0c3b1308606c6a2b648df71b.svg";
export { ForwardRef as ReactComponent };